import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { FetchCertifications, FetchCertificationsSuccess } from '../actions';
import { Certification } from '../models/certification';

export class CertificationsDataSource implements DataSource<Certification> {
    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    constructor(private _filteredReport$: Observable<Certification[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<Certification[]> {
        return this._filteredReport$;
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    async loadCertifications(pageSize?: number, pageNumber?: number, search?: string, provider?: string[], statuses?: number[]): Promise<void> {
        this._loadingSubject.next(true);

        this._store.dispatch(
            new FetchCertifications({
                pageSize,
                pageNumber,
                search,
                provider,
                statuses,
            })
        );
        this._action$
            .pipe(
                ofActionDispatched(FetchCertificationsSuccess),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
